import { STATUS_MAP } from "@/lib/api";

export default function StatusBadge({ status }) {
  const info = STATUS_MAP[status] || { label: status, cls: "bg-gray-100 text-gray-700 border-gray-200" };
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${info.cls}`}
      data-testid={`status-${status}`}
    >
      {info.label}
    </span>
  );
}
